export default "__VITE_ASSET__BEkmRQK9__"